import type React from 'react';

import { fieldError, setClass } from '../../helpers/utils';
import './styles.scss';

type SwitchProps = {
	name?: string;
	label?: React.ReactNode;
	checked?: boolean;
	disabled?: boolean;
	className?: string;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	value?: string | number;
	hookForm?: any;
};

export const Switch = ({
	name = '',
	label,
	checked,
	disabled,
	className = '',
	onChange,
	value,
	hookForm = { formState: { errors: {} } } as any,
}: SwitchProps) => {
	const {
		register,
		formState: { errors },
	} = hookForm;

	const handleChange = (event) => {
		if (typeof onChange === 'function') {
			onChange(event);
		}
	};

	return (
		<div
			className={setClass(`switch-contain
        ${fieldError(errors, name) ? 'is-error' : ''}
        ${disabled ? 'is-disabled' : ''}
        ${!label ? 'is-notlabel' : ''}
        ${className}`)}
		>
			<label className="switch">
				<input
					className="input-switch"
					type="checkbox"
					name={name}
					value={value}
					defaultChecked={checked}
					disabled={disabled}
					{...register?.(name, {
						onChange: (e) => handleChange(e),
					})}
				/>
				<span>{label}</span>
				<span className="slider"></span>
			</label>
			{fieldError(errors, name) && (
				<span className="message-error">
					{(fieldError(errors, name) as any).message}
				</span>
			)}
		</div>
	);
};
